export interface ITimeTableInputProps {
  inputTitle?: string;
  onChangeTimeTableHandler: (value: IWeekWorkTime | null) => void;
  inputTimeTable: IWeekWorkTime | null;
  showEmployeeOption?: boolean;
  isWorkTimeByEmployee?: boolean;
  onSwitchChange?: (active: boolean) => void;
}
export interface IWeekTimeSlots {
  onChangeHandler: (value: IWeekWorkTime) => void;
  newTimeTable: IWeekWorkTime;
}
export interface IDayTimeSlots {
  onChangeHandler: (value: IWeekWorkTime) => void;
  newDaySlot: IWeekWorkTime;
}
export enum WeekDaysEnum {
  Пн = 'Пн',
  Вт = 'Вт',
  Ср = 'Ср',
  Чт = 'Чт',
  Пт = 'Пт',
  Сб = 'Сб',
  Вс = 'Вс',
}

export const daysOfWeek: WeekDaysEnum[] = [
  WeekDaysEnum.Пн,
  WeekDaysEnum.Вт,
  WeekDaysEnum.Ср,
  WeekDaysEnum.Чт,
  WeekDaysEnum.Пт,
  WeekDaysEnum.Сб,
  WeekDaysEnum.Вс,
];

export const enum WeekDaysEnumEng {
  monday = 'monday',
  tuesday = 'tuesday',
  wednesday = 'wednesday',
  thursday = 'thursday',
  friday = 'friday',
  saturday = 'saturday',
  sunday = 'sunday',
}

export const daysOfWeekEng: WeekDaysEnumEng[] = [
  WeekDaysEnumEng.monday,
  WeekDaysEnumEng.tuesday,
  WeekDaysEnumEng.wednesday,
  WeekDaysEnumEng.thursday,
  WeekDaysEnumEng.friday,
  WeekDaysEnumEng.saturday,
  WeekDaysEnumEng.sunday,
];

export const enum TimeStates {
  start = 'start',
  end = 'end',
}

export type RangeTimeTableType = string[] | null[];

export type TimeTableType = {
  [key in WeekDaysEnum]: RangeTimeTableType;
};

export interface IWeekWorkTime {
  [day: string]: IWorkingTimeDay;
}
export interface IWorkingTimeDay {
  start: string | null;
  end: string | null;
}
